/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Badge,
    Banner,
    BlockStack,
    Button,
    Card,
    Checkbox,
    FormLayout,
    Icon,
    Page,
    Select,
    Text,
    TextField,
    Tooltip,
  } from "@shopify/polaris";
  import { AlertTriangleIcon, InfoIcon, MoonIcon, SunIcon } from "@shopify/polaris-icons";
  import { Controller, useForm } from "react-hook-form";
  import { useCreateAndUpdateSettingsMutation } from "../store/store/slices/SettingsRTK";
  import { useEffect, useState } from "react";
  import { useGetStoreSettingsQuery } from "../store/store/slices/UsersRTK";
  import { useDispatch } from "react-redux";
  import { showToast } from "../store/store/slices/AlertSlice";
  import { useNavigate } from "react-router-dom";
  import { useGetPreferencesAccountsQuery, useSetDefaultAccountMutation } from "../store/store/slices/AccountRTK";
  
  const Preferences = () => {
 

    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);
    const [selected, setSelected] = useState(localStorage.getItem("theme") || "light");
    const params = new URLSearchParams(window.location.search);
    const {
      data: accounts,
      isLoading: accountsLoading,
      isFetching,

    } = useGetPreferencesAccountsQuery<any>({
      page: params.get("page") || "1",
      limit: params.get("limit") || "50",
    });
    const [setDefaultAccount, {isLoading: setDefaultAccountLoading, isSuccess: setDefaultAccountSuccess}] = useSetDefaultAccountMutation()

    const handleSelectChange = (value: string) => {
      setSelected(value);
      localStorage.setItem("theme", value);
    
      // 👇 notify App that theme changed
      window.dispatchEvent(
        new CustomEvent("themeChanged", { detail: { value } })
      );
    };
    
    const handleAccountChange = (value: string) => {
      if(value?.trim()){
        setDefaultAccount({tracking_account_id: value});
      }
    };
  
   
   
  
    
  
    return (
      <Page
        narrowWidth
        title="User Preferences"
        backAction={{
          onAction: () => {
            navigate(-1);
          },
        }}
      >
        <BlockStack gap={"400"}>
          
          <Card>
    <BlockStack gap="300">
      <Text as="h1" fontWeight="bold" variant="bodyLg">
        User preferences
      </Text>
  
      <Select
        label="Theme"
        options={[
          {
            label: (
              <div style={{ display: "flex", width: "100px" }}>
                <p>Light mode </p>
                <Icon source={SunIcon} tone="base" />
              </div>
            ) as any,
            value: "light",
          },
          {
            label: (
              <div style={{ display: "flex", width: "100px" }}>
                <p>Dark mode </p>
                <Icon source={MoonIcon} tone="base" />
              </div>
            ) as any,
            value: "dark",
          },
        ]}
        onChange={handleSelectChange}
        value={selected}
      />
  
  <Select
    label="Default Booking Account: (This account will be automatically selected on booking page)"
    options={
      accounts?.accounts?.length
        ? accounts.accounts.map((acc: any) => ({
            label: `${acc?.name} (${acc?.company}) ${
              acc?.is_default ? " - Default account" : ""
            }`,
            value: acc._id,
          }))
        : []
    }
    value={
      accounts?.accounts?.find((a: any) => a.is_default)?._id || ""
    }
    disabled={accountsLoading || isFetching}
    onChange={handleAccountChange}
    
    placeholder={
      !accounts?.accounts?.find((a: any) => a.is_default)
        ? "Select your default account"
        : undefined
    }
  />
  
    </BlockStack>
  </Card>
  
        </BlockStack>
      </Page>
    );
  };
  
  export default Preferences;